import { render } from "./RegsDoctorsView.vue?vue&type=template&id=d62c8f8e"
import script from "./RegsDoctorsView.vue?vue&type=script&lang=js"
export * from "./RegsDoctorsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../DEV/_vue3/reactive-clinic/rc-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__